export default "__VITE_ASSET__cT$meaQ2__"